export class PromptExamplesPageController {
  selectPrompt(
    prompt: string,
    onSelect: (prompt: string) => void
  ): void {
    onSelect(prompt);
  }

  copyPrompt(
    prompt: string,
    id: string,
    onCopy: (text: string, id: string) => void
  ): void {
    onCopy(prompt, id);
  }
}